export default {
  methods: {
    openLinkNewTab(link) {
      const win = window.open(link, '_blank')
      win.focus()
    }
  }
}
